<template>

	<AuthStepBasicDialog :errorMessage="state.errorMessage">



		<template #icon>
			<PadlockIcon></PadlockIcon>
		</template>



		<template #title>
			Forgot Your Password?
		</template>



		<template #description>
			Enter the email address associated with your account.
		</template>



		<template v-slot:form>
			<v-form @submit.prevent="submitForm" lazy-validation ref="formRef"
				class="w-100 d-flex flex-column align-center">



				<CustomInput
					label="Email" placeholder="Type your email" type="email" v-model="state.email"
					:error-messages="v$.email.$errors.map(e => e.$message)" @blur="v$.email.$touch()" />



				<button type="submit" :loading="v$.$pending" :disabled="v$.$invalid"
					class="  button--primary rounded-pill text-15 weight-600 px-12 py-4 mt-5">
					Reset Password
				</button>



			</v-form>
		</template>





		<template v-slot:footer>
			<BackToLogin />
		</template>


	</AuthStepBasicDialog>
</template>



<script setup lang="ts">

import useVuelidate from '@vuelidate/core';
import forgotPasswordEvents from '@/Events/ForgotPassword';
import { ErrorResponse } from '@/interfaces/ErrorResponse';
import PadlockIcon from '@/icons/ResetPassword/Padlock.vue';
import { forgotPasswordEmailRules } from '@/utils/ValidationRules';
import CustomInput from '@/components/Common/CustomInput.vue';
import { provide, reactive, ref, onMounted, onUnmounted } from 'vue';
import { ForgotPasswordService } from '@/api/services/ForgotPasswordService';
import BackToLogin from '@/components/Auth/ForgotPassword/Actions/Back-To-Login.vue';
import AuthStepBasicDialog from '@/components/Auth/Common/Auth-Steps-Basic-Dialog.vue';
import { IForgotPasswordEmailRequestResponse } from '@/interfaces/ForgotPassword/IForgotPasswordEmailRequestResponse';




const state = reactive({
	email: '',
	errorMessage: '',
});
const v$ = useVuelidate(forgotPasswordEmailRules, state);




const dialogVisible = ref(false);
provide('openDialog', dialogVisible);





const submitForm = async () => {
	state.errorMessage = '';
	const isFormCorrect = await v$.value.$validate();
	if (isFormCorrect) {
		try {
			const emailRequestResponse: IForgotPasswordEmailRequestResponse = await ForgotPasswordService.emailRequest(state.email);
			if (emailRequestResponse.success) {
				forgotPasswordEvents.emit('forgot-password-email-link-sent', state.email);
				closeForgotPasswordDialog();
			} else {
				state.errorMessage = emailRequestResponse.message;
			}
		} catch (error: ErrorResponse | any) {
			state.errorMessage = error.friendly_message;
		}
	}
};








const openForgotPasswordDialog = () => {
	dialogVisible.value = true;
};
const closeForgotPasswordDialog = () => {
	dialogVisible.value = false;
}

onMounted(() => {
	forgotPasswordEvents.on('forgot-password-clicked', openForgotPasswordDialog);
	forgotPasswordEvents.on('open-forgot-password-enter-email-dialog', openForgotPasswordDialog);
});

onUnmounted(() => {
	forgotPasswordEvents.off('forgot-password-clicked', openForgotPasswordDialog);
	forgotPasswordEvents.off('open-forgot-password-enter-email-dialog', openForgotPasswordDialog);
});

</script>







<style scoped lang="scss">
.div {}

// this is just a dummy class because the global styles are not applying if we don't have any styles in the file
</style>